import React from 'react';
import OwlCarousel2 from 'react-owl-carousel2';
import { toggleWidget } from 'react-chat-widget';

const owloptions = {
    loop:true,
    margin:10,
    nav:false,
    autoplay: true,
    autoplayTimeout: 5000,
    items: 3,
    slideBy: 1,
    responsive:{
        0:{
            items:1,
            slideBy: 1,
            autoplayTimeout: 5000
        },
        900:{
            items:3
        },
        1000:{
            items:3
        }
    }
};


class FeatureSlider extends React.Component {

	render() {
        
        return (

<div className="fullwidth dark">
	<div className="row">
		<div className="twelve columns">
    	<OwlCarousel2 options={owloptions}>
			<div className="item">
				<h5>Always-on Mitigation</h5>
				<hr className="grey"/>
				<div className="left paddingright"><i className="fa-solid fa-certificate fa-5x" aria-hidden="true"></i></div>
				<p>Protection runs inline at the network edge and engages automatically. Malicious traffic is filtered before it reaches your server so services stay reachable. This keeps users online without manual steps or downtime during most attacks.</p>
			</div>
			<div className="item">
				<h5>Volumetric Filtering</h5>
				<hr className="grey"/>
				<div className="left paddingright"><i className="fa-solid fa-shield-halved fa-5x" aria-hidden="true"></i></div>
				<p>High-capacity edge filtering stops amplification floods such as UDP, DNS, and NTP before they saturate links or reach your infrastructure. The goal is to keep bandwidth available for legitimate traffic at all times.</p>
			</div>
			<div className="item">
				<h5>Protocol Flood Defense</h5>
				<hr className="grey"/>
				<div className="left paddingright"><i className="fa fa-sliders fa-5x" aria-hidden="true"></i></div>
				<p>Dedicated anti-DDoS systems mitigate L4 protocol attacks like TCP SYN/ACK and GRE floods that target state tables and network stacks. This preserves server resources and prevents connection exhaustion.</p>
			</div>
			<div className="item">
				<h5>Fast Engagement</h5>
				<hr className="grey"/>
				<div className="left paddingright"><i className="fa fa-exchange fa-5x" aria-hidden="true"></i>
				</div>
				<p>Mitigation activates within seconds during an attack, keeping legitimate traffic flowing without manual intervention. The response is automated so protection is consistent even for sudden traffic spikes.</p>
			</div>
			<div className="item">
				<h5>Clean Traffic Delivery</h5>
				<hr className="grey"/>
				<div className="left paddingright"><i className="fa fa-wrench fa-5x" aria-hidden="true"></i></div>
				<p>Legitimate traffic is forwarded while malicious packets are dropped. Your server keeps running without changes or extra load. This minimizes collateral impact for real users.</p>
			</div>
			<div className="item">
				<h5>Low False Positives</h5>
				<hr className="grey"/>
				<div className="left paddingright"><i className="fa fa-bolt fa-5x" aria-hidden="true"></i></div>
				<p>Filtering is tuned to keep real users online while blocking attack traffic, reducing collateral impact during mitigation. This helps maintain normal access patterns even under stress.</p>
			</div>
			<div className="item">
				<h5>Swiss Network Location</h5>
				<hr className="grey"/>
				<div className="left paddingright"><i className="fa fa-bullseye fa-5x" aria-hidden="true"></i></div>
				<p>Strategic location in Switzerland provides stability, neutrality, and strong privacy laws for mission critical infrastructure. It is ideal for sensitive services that require consistent availability.</p>
			</div>
			<div className="item">
				<h5>Included With Our Servers</h5>
				<hr className="grey"/>
				<div className="left paddingright"><i className="fa-solid fa-map-marker fa-5x" aria-hidden="true"></i></div>
				<p>DDoS protection is included with Dedicated Servers and Confidential Servers, so your workloads are protected by default. You get automatic mitigation without extra configuration or setup.</p>
			</div>
			<div className="item">
				<h5>Over {new Date().getFullYear() - 2011} Years of Expertise</h5>
				<hr className="grey"/>
				<div className="left paddingright"><strong className="fa-5x"></strong></div>
				<p>We have been mitigating DDoS attacks since our founding, with a focus on reliable network protection and stable service delivery. Long-term operational experience means predictable performance, fast response, and a mature mitigation stack.</p>
			</div>
			<div className="item">
				<h5>24/7 Live Support</h5>
				<hr className="grey"/>
				<div className="left paddingright"><i className="fa fa-headphones fa-5x" aria-hidden="true"></i></div>
				<p><span className="swissmade">Swiss <i className="fa fa-plus-square" aria-hidden="true"></i> Made</span> provides live around-the-clock sales and technical support. Reach us via the <a href="/en/" onClick={function(event){event.preventDefault();toggleWidget()}} title="Start a chat">live chat</a> widget or open a support ticket in your <a href={'//' + process.env.REACT_APP_MEMBER_DOMAIN}>account area</a>.</p>
			</div>
			<div className="item">
				<h5>Swiss Approach</h5>
				<hr className="grey"/>
				<div className="left paddingright"><i className="fa fa-plus-square fa-5x colored" aria-hidden="true"></i></div>
				<p>SwissMade.host is a Zurich-based web hosting company built on Switzerland's privacy, neutrality, and quality standards. Orders and requests follow strict privacy, data protection, and quality assurance policies.</p>
			</div>
		</OwlCarousel2>
		</div>
	</div>
</div>

            )
            }}

export default FeatureSlider
